var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"discuss-wrap"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c(_vm.dynamComp,{tag:"component",attrs:{"searchData":_vm.searchData,"detailInfo":_vm.detail},on:{"goDiscussion":_vm.goDiscussion,"goBackMarking":_vm.goBackMarking,"goSearch":_vm.goSearch}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }